import { Navigate } from "react-router-dom";
import { routes } from "../helpers/constants";
import MedRepLogin from "../pages/Login/MedRepLogin";
import AdminLogin from "../pages/Login/AdminLogin";
import Registration from "../pages/Registration";
import Courses from "../pages/Courses";
import CourseModules from "../pages/Courses/CourseModules";
import ViewCourseModule from "../pages/Courses/ViewCourseModule";
import Test from "../pages/Test";
import ActualTest from "../pages/Test/ActualTest";

export const authRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.login} /> },
  { path: routes.login, element: <MedRepLogin /> },
  { path: routes.adminLogin, element: <AdminLogin /> },
];

export const mainRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.courses} /> },
  { path: routes.courses, element: <Courses /> },
  { path: routes.courseModule, element: <CourseModules /> },
  { path: routes.moduleViewing, element: <ViewCourseModule /> },
  { path: routes.test, element: <Test /> },
  { path: routes.actualTest, element: <ActualTest /> },
];

export const adminRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.registration} /> },
  { path: routes.registration, element: <Registration /> },
];

export const invalidRoutes = [
  { path: "*", element: <MedRepLogin /> },
  { path: routes.login, element: <MedRepLogin /> },
  { path: routes.adminLogin, element: <AdminLogin /> },
];
